import React, { useState, useEffect, useRef } from 'react';
import "./AddProjectGroup.css"
import { projectGroupUpload } from '../../../api/project/projectApi'




const AddProjectGroup = ({setShowCreateProject, onSuccess}) => {
    const [projectName, setProjectName] = useState("");
    const [projectDesc, setProjectDesc] = useState("");
    const [projectPassword, setProjectPassword] = useState("");


    
    
  
    const handleSubmit = async () => {
      if (!projectName || !projectDesc) {
        alert("프로젝트 이름과 설명은 필수입니다.");
        return;
      }
  
      try {
        const payload = {
          projectGroupName: projectName,
          projectGroupDesc: projectDesc,
          projectGroupPassword: projectPassword || null,
        };
  
        const res = await projectGroupUpload(payload);
        alert(res.message || "프로젝트 그룹이 생성되었습니다.");
        //모달 창 닫기
        setShowCreateProject(false);
  
        // 입력창 초기화
        setProjectName("");
        setProjectDesc("");
        setProjectPassword("");
        if (onSuccess) onSuccess(); // ✅ 성공 시 부모에게 알림
      } catch (error) {
        alert("생성 실패: " + (error.message || "알 수 없는 오류"));
      }
    };
  
    const handleCancel = () => {
      setProjectName("");
      setProjectDesc("");
      setProjectPassword("");
      setShowCreateProject(false);
    };
  
    return (
      <div className='AddProject_Container'>
        <div className='AddProject_TitleBox'>프로젝트 추가</div>
  
        <div className='AddProject_NameContainer'>
          <div className='AddProject_NameBox'>프로젝트 이름</div>
          <input
            type='text'
            className='AddProject_NameTextFelid'
            placeholder="프로젝트 이름을 입력하세요"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
          />
        </div>
  
        <div className='AddProject_MemoContainer'>
          <div className='AddProject_NameBox'>프로젝트 설명</div>
          <input
            type='text'
            className='AddProject_MemoTextFelid'
            placeholder="프로젝트 설명을 입력하세요"
            value={projectDesc}
            onChange={(e) => setProjectDesc(e.target.value)}
          />
        </div>
  
        <div className='AddProject_NameContainer'>
          <div className='AddProject_NameBox'>프로젝트 비밀번호</div>
          <input
            type='password'
            className='AddProject_NameTextFelid'
            placeholder="프로젝트 비밀번호를 입력하세요"
            value={projectPassword}
            onChange={(e) => setProjectPassword(e.target.value)}
          />
        </div>
  
        <div className='AddProject_BtnContainer'>
          <div className='AddProject_Btn' onClick={handleSubmit}>생성</div>
          <div className='AddProject_Btn' onClick={handleCancel}>닫기</div>
        </div>
      </div>
    );
  };
  
  export default AddProjectGroup;